/* MAUK · Lighting Finder — generic guided-selling engine.
   Store-agnostic: all copy, vocabulary, weights and steps come from the JSON
   config rendered by sections/mauk-finder.liquid. Catalog = finder-catalog.json
   (generated from metafields by build_catalog.py).
   State machine: steps -> loading -> results. Answers mirrored in URL params. */
(function () {
  'use strict';

  var ROOT, STAGE, CFG, CAT = [], IMG_BASE = '', SAVE_FORM = null;
  var A = {};            // answers: stepKey -> option object, or SKIP
  var hist = [];
  var refine = { budget: 0, toggles: {} };
  var relaxed = [];      // which constraints were loosened to avoid a dead-end
  var liveCache = {};    // handle -> {price, available} from /products/{handle}.js
  var SKIP = { k: '-', skip: true };

  /* ---------- utils ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    if (n == null || isNaN(n)) return '';
    var s = Math.round(n) === n ? String(n) : n.toFixed(2);
    return CFG.currency + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function norm(s) { return String(s).toLowerCase().trim(); }
  function intersects(arr, vals) {
    if (!arr || !vals) return false;
    for (var i = 0; i < vals.length; i++) {
      var v = norm(vals[i]);
      for (var j = 0; j < arr.length; j++) if (norm(arr[j]) === v) return true;
    }
    return false;
  }
  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: 'finder_' + event };
      if (data) for (var k in data) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break the finder */ }
  }
  function imgUrl(p, size) {
    if (!p.img) return '';
    var u = IMG_BASE + p.img;
    return size ? u.replace('_600x600', '_' + size + 'x' + size) : u;
  }

  /* ---------- icons (generic lighting/room glyphs, stroke line style) ---------- */
  var ICONS = {
    sofa: '<path d="M4 11V8a2 2 0 012-2h12a2 2 0 012 2v3"/><path d="M3 11a2 2 0 012 2v3h14v-3a2 2 0 014 0v5H1v-5a2 2 0 012-2z"/>',
    bed: '<path d="M3 18v-6a2 2 0 012-2h14a2 2 0 012 2v6M3 14h18M3 18v2M21 18v2M6 10V8a2 2 0 012-2h2a2 2 0 012 2v2"/>',
    table: '<path d="M3 9h18M4 9l1 11M20 9l-1 11M8 9v4M16 9v4"/>',
    island: '<rect x="4" y="11" width="16" height="8"/><path d="M4 15h16M12 3v4M9 5h6"/>',
    door: '<path d="M6 21V4a1 1 0 011-1h10a1 1 0 011 1v17M4 21h16M14 12h.01"/>',
    pendant: '<path d="M12 3v5M7 13a5 5 0 0110 0zM6 13h12M10 17a2 2 0 004 0"/>',
    chandelier: '<path d="M12 3v4M12 7c-5 0-7 3-7 6M12 7c5 0 7 3 7 6M5 13v2M19 13v2M12 7v8M12 15v2M4 16a1 1 0 002 0M18 16a1 1 0 002 0M11 18a1 1 0 002 0"/>',
    flush: '<path d="M4 6h16M7 6a5 5 0 0010 0"/>',
    sconce: '<path d="M5 3v18M5 10h5a3 3 0 013 3M12 13h4l-2-4h-4"/>',
    ceilstd: '<path d="M4 5h16M4 19h16M12 5v3M8 19v-4h8v4M12 11a2 2 0 100 .01"/>',
    ceilhigh: '<path d="M4 3h16M4 21h16M12 3v5M8 21v-4h8v4M12 13a2 2 0 100 .01"/>',
    check: '<path d="M20 6L9 17l-5-5"/>',
    arrowL: '<path d="M19 12H5M12 19l-7-7 7-7"/>',
    link: '<path d="M10 13a5 5 0 007.5.5l3-3a5 5 0 00-7-7l-1.7 1.7M14 11a5 5 0 00-7.5-.5l-3 3a5 5 0 007 7l1.7-1.7"/>'
  };
  function icon(name, cls) {
    return '<svg class="' + (cls || 'fdr-ic') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }
  function sun() {
    var r = '';
    for (var i = 0; i < 12; i++) {
      var a = i * 30 * Math.PI / 180;
      r += '<line x1="' + (12 + Math.cos(a) * 4).toFixed(1) + '" y1="' + (12 + Math.sin(a) * 4).toFixed(1) + '" x2="' + (12 + Math.cos(a) * 9.5).toFixed(1) + '" y2="' + (12 + Math.sin(a) * 9.5).toFixed(1) + '"/>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="2.4"/>' + r + '</svg>';
  }

  /* ---------- steps plan ---------- */
  function stepVisible(step) {
    if (!step.dependsOn) return true;
    for (var key in step.dependsOn) {
      var ans = A[key];
      if (!ans || ans.skip || step.dependsOn[key].indexOf(ans.k) < 0) return false;
    }
    return true;
  }
  function plan() {
    var p = [];
    for (var i = 0; i < CFG.steps.length; i++) if (stepVisible(CFG.steps[i])) p.push(CFG.steps[i].key);
    p.push('results');
    return p;
  }
  function stepByKey(k) {
    for (var i = 0; i < CFG.steps.length; i++) if (CFG.steps[i].key === k) return CFG.steps[i];
    return null;
  }
  function answered(step) { return !!A[step.key]; }
  function nextScreen() {
    var p = plan();
    for (var i = 0; i < p.length - 1; i++) if (!answered(stepByKey(p[i]))) return p[i];
    return 'results';
  }

  /* ---------- URL state ---------- */
  function syncUrl() {
    try {
      var q = new URLSearchParams();
      for (var i = 0; i < CFG.steps.length; i++) {
        var st = CFG.steps[i];
        if (A[st.key]) q.set(st.param, A[st.key].k);
      }
      var qs = q.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + (hist[hist.length - 1] === 'results' ? '#results' : ''));
    } catch (e) { /* sandboxed contexts */ }
  }
  function restoreFromUrl() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    for (var i = 0; i < CFG.steps.length; i++) {
      var st = CFG.steps[i], v = q.get(st.param);
      if (!v) continue;
      if (v === '-') { A[st.key] = SKIP; continue; }
      for (var j = 0; j < st.options.length; j++) {
        if (st.options[j].k === v) { A[st.key] = st.options[j]; break; }
      }
    }
  }

  /* ---------- scoring ---------- */
  function paletteMatch(p, match) {
    if (!match) return false;
    if (match.colours && intersects(p.colours, match.colours)) return true;
    if (match.finish && intersects(p.finish, match.finish)) return true;
    if (match.materials && intersects(p.materials, match.materials)) return true;
    return false;
  }
  function budgetCap() {
    if (refine.budget) return refine.budget >= CFG.budgetMax ? 0 : refine.budget;
    var b = A.budget;
    if (!b || b.skip || !b.cap) return 0;
    return b.cap;
  }
  function budgetMin() {
    if (refine.budget) return 0; // the refine slider overrides the whole budget answer, floor included
    var b = A.budget;
    return (b && !b.skip && b.min) ? b.min : 0;
  }

  /* relaxLevel: 0 strict, 1 format soft, 2 format+budget soft */
  function score(p, relaxLevel) {
    var W = CFG.weights, s = 0, reasons = [];

    if (A.room && !A.room.skip) {
      if (!intersects(p.rooms, A.room.match)) return null;
      s += W.room; reasons.push(CFG.copy.reasonRoom);
    }
    var f = A.format;
    if (f && !f.skip) {
      if (p.format !== f.k) {
        if (relaxLevel < 1) return null;
        s -= 2;
      } else { s += 2; }
    } else if (p.format === 'pendant') { s += W.guidePendant || 0; }

    var cap = budgetCap(), min = budgetMin();
    if (cap) {
      if (p.price > cap) {
        if (relaxLevel < 2) return null;
        s += W.budgetOverPenalty;
      } else {
        // flat in-budget bonus + mild preference for the upper half of the band
        // (premium positioning: never crown the cheapest match by default)
        s += 1;
        if (p.price >= cap * 0.4) s += 0.5;
      }
    }
    if (min && p.price < min && relaxLevel < 2) return null;

    if (A.style && !A.style.skip && intersects(p.styles, A.style.match)) {
      s += W.style; reasons.push(CFG.copy.reasonStyle.replace('{style}', A.style.label.toLowerCase()));
    }
    if (A.palette && !A.palette.skip && paletteMatch(p, A.palette.match)) {
      s += W.palette; reasons.push(CFG.copy.reasonPalette.replace('{palette}', A.palette.label.toLowerCase()));
    }
    if (A.ceiling && !A.ceiling.skip) {
      if (A.ceiling.k === 'high') {
        if ((p.h || 0) >= (CFG.tallHeightCm || 48) || p.adj) { s += W.ceilingHigh; reasons.push(CFG.copy.reasonTall); }
        else if (p.h && p.h < 30) { s -= 1; }
      } else if (p.h && p.h <= 50) { s += W.ceilingStd; }
      if (A.ceiling.k === 'standard' && p.adj) s += 1;
    }

    if (refine.toggles.larger) s += (p.w || 0) / 30;
    if (refine.toggles.brass && paletteMatch(p, CFG.refineBrassMatch)) s += 3;
    if (refine.toggles.softer && intersects(p.materials, CFG.softMaterials)) s += 3;
    if (refine.toggles.bulb && p.bulb === 1) { s += 4; }

    if (p.img) s += 0.3;
    if (p.w && p.h) s += 0.4;
    // popularity: gentle tie-breaker among equally-matching pieces, never above need
    s += (W.popularity || 0) * (p.pop || 0);

    var live = liveCache[p.handle];
    if (live && live.available === false) return null;

    return { p: p, s: s, reasons: reasons };
  }

  function ranked() {
    relaxed = [];
    for (var level = 0; level <= 2; level++) {
      var out = [];
      for (var i = 0; i < CAT.length; i++) {
        var r = score(CAT[i], level);
        if (r) out.push(r);
      }
      if (out.length >= 4 || level === 2) {
        if (level >= 1 && A.format && !A.format.skip) relaxed.push('format');
        if (level >= 2 && budgetCap()) relaxed.push('budget');
        out.sort(function (a, b) { return b.s - a.s; });
        return out;
      }
    }
    return [];
  }

  /* Dynamic Answers: hide options that would lead near a dead-end (MUST benchmark #4). */
  function optionCount(step, opt) {
    var n = 0;
    for (var i = 0; i < CAT.length; i++) {
      var p = CAT[i];
      if (A.room && !A.room.skip && !intersects(p.rooms, A.room.match)) continue;
      if (step.role === 'format') { if (p.format !== opt.k) continue; }
      else if (step.role === 'palette') {
        if (A.format && !A.format.skip && p.format !== A.format.k) continue;
        if (!paletteMatch(p, opt.match)) continue;
      } else if (opt.match && !intersects(p[step.role + 's'] || [], opt.match)) continue;
      n++;
      if (n >= (CFG.minOptionCount || 3)) return n;
    }
    return n;
  }

  /* ---------- navigation ---------- */
  /* answers of steps hidden by their dependsOn must never leak into scoring
     (forged/partial URLs, format changed after answering ceiling) */
  function pruneAnswers() {
    for (var i = 0; i < CFG.steps.length; i++) {
      var st = CFG.steps[i];
      if (A[st.key] && !stepVisible(st)) delete A[st.key];
    }
  }
  function go(screen) { pruneAnswers(); hist.push(screen); render(screen); syncUrl(); }
  function back() {
    hist.pop();
    var prev = hist[hist.length - 1];
    if (!prev) { prev = CFG.steps[0].key; hist = [prev]; }
    var st = stepByKey(prev);
    if (st) delete A[st.key];
    render(prev); syncUrl();
  }
  function restart() {
    A = {}; hist = []; relaxed = [];
    refine = { budget: 0, toggles: {} };
    try { history.replaceState(null, '', location.pathname); } catch (e) { /* noop */ }
    go(CFG.steps[0].key);
    track('start');
  }

  /* ---------- render: shared ---------- */
  function stepbar(cur) {
    var p = plan(), idx = p.indexOf(cur), total = p.length;
    var pct = Math.round(((idx + 1) / total) * 100);
    var h = '<div class="fdr-stepbar">';
    if (idx > 0) h += '<button type="button" class="fdr-back" data-a="back">' + icon('arrowL', '') + esc(CFG.copy.back) + '</button>';
    h += '<div class="fdr-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="' + esc(CFG.copy.progressLabel) + '"><i style="width:' + pct + '%"></i></div>';
    h += '<span class="fdr-count">' + Math.min(idx + 1, total) + ' / ' + total + '</span></div>';
    return h;
  }
  function chk() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS.check + '</svg>'; }

  /* poster image for a photo option: config override, else auto-picked from catalog.
     Dedup across options of the step + prefer products whose DOMINANT style matches. */
  function posterFor(opt, used) {
    if (opt.img) return opt.img;
    var best = null, bestD = 1e9, target = CFG.posterPrice || 150;
    for (var i = 0; i < CAT.length; i++) {
      var p = CAT[i];
      if (!p.img || !intersects(p.styles, opt.match)) continue;
      if (used && used[p.id]) continue;
      var d = Math.abs(p.price - target)
        + (p.format === 'pendant' ? 0 : 40)
        + (p.w && p.h ? 0 : 25)
        + (p.styles[0] === opt.match[0] ? 0 : 60)
        + (p.styles.length - 1) * 15
        - (p.pop || 0) * 40;
      if (d < bestD) { bestD = d; best = p; }
    }
    if (best && used) used[best.id] = true;
    return best ? imgUrl(best) : '';
  }

  function optionHtml(step, opt, i, used) {
    var name = 'fdr-' + step.key;
    var input = '<input type="radio" name="' + name + '" value="' + esc(opt.k) + '" data-step="' + esc(step.key) + '"' + (A[step.key] && A[step.key].k === opt.k ? ' checked' : '') + '>';
    var checked = (A[step.key] && A[step.key].k === opt.k) ? ' is-checked' : '';
    if (step.type === 'photo') {
      var src = posterFor(opt, used);
      return '<label class="fdr-opt fdr-opt--photo' + checked + '">' + input +
        '<span class="fdr-fig">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="600" height="600">' : '') + '</span>' +
        '<span class="fdr-txt"><span class="fdr-nm">' + esc(opt.label) + '</span>' +
        (opt.sub ? '<br><span class="fdr-sub">' + esc(opt.sub) + '</span>' : '') + '</span></label>';
    }
    if (step.type === 'swatch') {
      return '<label class="fdr-opt fdr-opt--swatch' + checked + '">' + input +
        '<span class="fdr-sw" style="background:' + opt.sw + '" aria-hidden="true"></span>' +
        '<span><span class="fdr-nm">' + esc(opt.label) + '</span>' +
        (opt.sub ? '<br><span class="fdr-sub">' + esc(opt.sub) + '</span>' : '') + '</span></label>';
    }
    return '<label class="fdr-opt' + checked + '">' + input +
      '<span class="fdr-idx">0' + (i + 1) + '</span>' +
      (opt.icon ? icon(opt.icon) : '') +
      '<span class="fdr-nm">' + esc(opt.label) + '</span>' +
      (opt.sub ? '<span class="fdr-sub">' + esc(opt.sub) + '</span>' : '') + '</label>';
  }

  function render(screen) {
    if (screen === 'results') return loadingThenResults();
    var step = stepByKey(screen);
    if (!step) return restart();
    var h = stepbar(screen);
    h += '<fieldset class="fdr-fieldset"><legend><span class="fdr-eyebrow"><span class="fdr-dot"></span>' + esc(step.eyebrow) + '</span>' +
      '<span class="fdr-qtitle">' + esc(step.title) + '</span></legend>';
    var grid = step.type === 'photo' ? 'fdr-grid--photos' : step.type === 'swatch' ? 'fdr-grid--swatches' : (step.options.length <= 2 ? 'fdr-grid--duo' : 'fdr-grid--icons');
    h += '<div class="fdr-grid ' + grid + '">';
    var shown = 0, used = {};
    for (var i = 0; i < step.options.length; i++) {
      var opt = step.options[i];
      if (step.dynamic && optionCount(step, opt) < (CFG.minOptionCount || 3)) continue;
      h += optionHtml(step, opt, shown, used); shown++;
    }
    h += '</div>';
    if (step.skipLabel) {
      h += '<div class="fdr-skip"><button type="button" data-a="skip" data-step="' + esc(step.key) + '">' + esc(step.skipLabel) + '</button></div>';
    }
    h += '</fieldset>';
    STAGE.innerHTML = '<div class="fdr-fade">' + h + '</div>';
    STAGE.focus({ preventScroll: true });
    announce(step.title);
  }
  function announce(text) {
    var live = document.getElementById('fdr-live');
    if (live) live.textContent = text;
  }

  /* ---------- results ---------- */
  function loadingThenResults() {
    var h = '<div class="fdr-fade"><div class="fdr-loading" role="status"><h2>' + esc(CFG.copy.loadingTitle) + '</h2>' +
      '<div class="fdr-track"><i></i></div><div class="fdr-assure">';
    for (var i = 0; i < CFG.reassurance.length; i++) h += '<span>' + chk() + esc(CFG.reassurance[i]) + '</span>';
    h += '</div></div></div>';
    STAGE.innerHTML = h;
    setTimeout(function () {
      if (hist[hist.length - 1] === 'results') results();
    }, CFG.loadingMs || 900);
  }

  function whyCopy(hero) {
    var segs = [];
    if (A.style && !A.style.skip && intersects(hero.p.styles, A.style.match)) segs.push(CFG.copy.whyStyle.replace('{style}', A.style.label.toLowerCase()));
    if (A.palette && !A.palette.skip && paletteMatch(hero.p, A.palette.match)) segs.push(CFG.copy.whyPalette.replace('{palette}', A.palette.label.toLowerCase()));
    if (A.ceiling && !A.ceiling.skip && A.ceiling.k === 'high' && ((hero.p.h || 0) >= (CFG.tallHeightCm || 48) || hero.p.adj)) segs.push(CFG.copy.whyTall);
    else if (A.ceiling && !A.ceiling.skip && A.ceiling.k === 'standard') segs.push(CFG.copy.whyStd);
    var base = (A.room && !A.room.skip) ? CFG.copy.whyRoom.replace('{room}', A.room.label.toLowerCase()) : CFG.copy.whyNoRoom;
    return base + (segs.length ? ' — ' + segs.join(', ') : '') + '.';
  }
  function dims(p) {
    var bits = [];
    if (p.w) bits.push(CFG.copy.dimW.replace('{n}', p.w));
    if (p.h) bits.push(CFG.copy.dimH.replace('{n}', p.h));
    return bits.join(' · ');
  }
  function bulbLine(p) {
    if (p.bulb === 1) return CFG.copy.bulbIncluded;
    if (p.bulb === 0 && p.socket) return CFG.copy.bulbSocket.replace('{socket}', p.socket);
    if (p.socket) return CFG.copy.socketOnly.replace('{socket}', p.socket);
    return '';
  }
  function priceOf(p) {
    var live = liveCache[p.handle];
    return live && live.price != null ? live.price : p.price;
  }

  function card(h) {
    var p = h.p, d = dims(p);
    var tag = h.reasons.length ? '<span class="fdr-tag">' + esc(h.reasons[h.reasons.length - 1]) + '</span>' : '';
    return '<div class="fdr-pc"><a href="' + esc(CFG.productBase + p.handle) + '" class="fdr-pfig" aria-label="' + esc(p.title) + '">' +
      (p.img ? '<img src="' + esc(imgUrl(p)) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + tag + '</a>' +
      '<div class="fdr-pbody"><a class="fdr-pnm" style="color:inherit;text-decoration:none" href="' + esc(CFG.productBase + p.handle) + '">' + esc(p.title) + '</a>' +
      (d ? '<span class="fdr-pmeta">' + esc(d) + '</span>' : '') +
      '<span class="fdr-pfoot"><span class="fdr-pprice">' + money(priceOf(p)) + '</span>' +
      '<button type="button" class="fdr-padd" data-a="atc" data-vid="' + p.vid + '" data-handle="' + esc(p.handle) + '" aria-label="' + esc(CFG.copy.addToBasket + ' — ' + p.title) + '">' + esc(CFG.copy.quickAdd) + '</button></span></div></div>';
  }

  function refineBar() {
    var cap = refine.budget || (A.budget && !A.budget.skip && A.budget.cap) || CFG.budgetMax;
    var label = cap >= CFG.budgetMax ? CFG.copy.noLimit : CFG.copy.upTo.replace('{price}', money(cap));
    var h = '<div class="fdr-refine"><div class="fdr-rhead"><span class="fdr-eyebrow"><span class="fdr-dot"></span>' + esc(CFG.copy.refineTitle) + '</span>' +
      '<span class="fdr-budget" id="fdr-budget-label">' + esc(label) + '</span></div>' +
      '<input type="range" class="fdr-slider" id="fdr-budget" min="' + CFG.budgetSliderMin + '" max="' + CFG.budgetMax + '" step="25" value="' + Math.min(cap, CFG.budgetMax) + '" aria-label="' + esc(CFG.copy.refineBudgetAria) + '">' +
      '<div class="fdr-toggles">';
    for (var i = 0; i < CFG.refineToggles.length; i++) {
      var t = CFG.refineToggles[i];
      h += '<button type="button" class="fdr-tg' + (refine.toggles[t.k] ? ' on' : '') + '" data-a="tg" data-k="' + esc(t.k) + '" aria-pressed="' + (!!refine.toggles[t.k]) + '">' + esc(t.label) + '</button>';
    }
    return h + '</div></div>';
  }

  /* "Layer the room": complementary fittings around the hero (layered-lighting
     cross-sell). Scored with format made soft (level 1) so budget/room stay
     respected, then distinct formats preferred, wall/ceiling before another
     big central light. */
  var LAYER_PREF = { wall: 0, ceiling: 1, chandelier: 2, pendant: 3 };
  function layerPicks(hero, excludeIds) {
    var pool = [];
    for (var i = 0; i < CAT.length; i++) {
      var p = CAT[i];
      if (p.format === hero.p.format || p.id === hero.p.id || excludeIds[p.id]) continue;
      var r = score(p, 1);
      if (r) { r.reasons = [CFG.copy.reasonLayer]; pool.push(r); }
    }
    pool.sort(function (a, b) {
      var pa = LAYER_PREF[a.p.format] != null ? LAYER_PREF[a.p.format] : 4;
      var pb = LAYER_PREF[b.p.format] != null ? LAYER_PREF[b.p.format] : 4;
      return (b.s - pb * 2) - (a.s - pa * 2);
    });
    var picks = [], seenFormats = {};
    for (var j = 0; j < pool.length && picks.length < 3; j++) {
      if (seenFormats[pool[j].p.format]) continue;
      picks.push(pool[j]); seenFormats[pool[j].p.format] = true;
    }
    for (var k = 0; k < pool.length && picks.length < 3; k++) {
      var dup = false;
      for (var m = 0; m < picks.length; m++) if (picks[m].p.id === pool[k].p.id) dup = true;
      if (!dup) picks.push(pool[k]);
    }
    return picks;
  }

  function results() {
    var list = ranked();
    track('complete', { results: list.length });
    if (!list.length) {
      STAGE.innerHTML = '<div class="fdr-fade">' + stepbar('results') +
        '<div class="fdr-empty"><h2>' + esc(CFG.copy.emptyTitle) + '</h2><p>' + esc(CFG.copy.emptyBody) + '</p></div>' +
        refineBar() +
        '<div class="fdr-foot"><span class="fdr-contact"></span><button type="button" class="fdr-restart" data-a="restart">' + sun() + esc(CFG.copy.restart) + '</button></div></div>';
      return;
    }
    var hero = list[0], p = hero.p;
    var alts = list.slice(1, 4);
    var altIds = {};
    for (var ai = 0; ai < alts.length; ai++) altIds[alts[ai].p.id] = true;
    var layers = layerPicks(hero, altIds);
    var d = dims(p), bulb = bulbLine(p), price = priceOf(p);

    var h = stepbar('results');
    h += '<span class="fdr-eyebrow fdr-res-eyebrow"><span class="fdr-dot"></span>' +
      esc(A.room && !A.room.skip ? CFG.copy.resultEyebrow.replace('{room}', A.room.label.toLowerCase()) : CFG.copy.resultEyebrowNoRoom) + '</span>';
    h += '<h1 class="fdr-res-title">' + esc(p.title) + '</h1><div class="fdr-res-kicker">' + esc(CFG.copy.yourMatch) + '</div>';
    if (relaxed.length) {
      var rl = relaxed.indexOf('budget') >= 0 ? CFG.copy.relaxedBudget : CFG.copy.relaxedFormat;
      h += '<p class="fdr-relaxed">' + esc(rl) + '</p>';
    }
    h += '<div class="fdr-hero"><div class="fdr-hero-fig"><img src="' + esc(imgUrl(p, 1200)) + '" alt="' + esc(p.title) + '" width="900" height="900"></div><div>';
    h += '<p class="fdr-why">' + esc(whyCopy(hero)) + '</p>';
    h += '<div class="fdr-specs">';
    if (d) h += '<div class="fdr-row"><span class="fdr-k">' + esc(CFG.copy.specSize) + '</span><span class="fdr-v">' + esc(d) + (p.adj ? ' · ' + esc(CFG.copy.adjustable) : '') + '</span></div>';
    if (p.materials && p.materials.length) h += '<div class="fdr-row"><span class="fdr-k">' + esc(CFG.copy.specMaterials) + '</span><span class="fdr-v">' + esc(p.materials.join(', ')) + '</span></div>';
    if (bulb) h += '<div class="fdr-row"><span class="fdr-k">' + esc(CFG.copy.specBulb) + '</span><span class="fdr-v">' + esc(bulb) + '</span></div>';
    h += '</div>';
    h += '<div class="fdr-priceline"><span class="fdr-price">' + money(price) + '</span>' + (p.cap && p.cap > price ? '<span class="fdr-cap">' + money(p.cap) + '</span>' : '') + '</div>';
    if (CFG.copy.klarna) h += '<p class="fdr-klarna">' + esc(CFG.copy.klarna.replace('{price}', money(price / 3))) + '</p>';
    h += '<div class="fdr-cta"><button type="button" class="btn btn-primary" data-a="atc" data-vid="' + p.vid + '" data-handle="' + esc(p.handle) + '">' + esc(CFG.copy.addToBasket) + '</button>' +
      '<a class="fdr-view" href="' + esc(CFG.productBase + p.handle) + '">' + esc(CFG.copy.viewPiece) + '</a></div>';
    h += '<div class="fdr-assure" style="justify-content:flex-start">';
    for (var i = 0; i < CFG.reassurance.length; i++) h += '<span>' + chk() + esc(CFG.reassurance[i]) + '</span>';
    h += '</div></div></div>';

    h += '<div class="fdr-note">' + sun() + '<div><span class="fdr-eyebrow"><span class="fdr-dot"></span>' + esc(CFG.copy.noteTitle) + '</span><p>' + esc(noteCopy(p)) + '</p></div></div>';
    h += refineBar();

    if (alts.length) {
      h += '<div class="fdr-sel"><div class="fdr-selhead"><h3>' + esc(CFG.copy.altTitle) + '</h3><span class="fdr-selcount">' + esc(CFG.copy.altCount.replace('{n}', list.length)) + '</span></div><div class="fdr-cards">';
      for (var j = 0; j < alts.length; j++) h += card(alts[j]);
      h += '</div></div>';
    }
    if (layers.length) {
      h += '<div class="fdr-sel"><div class="fdr-selhead"><h3>' + esc(CFG.copy.layerTitle) + '</h3><span class="fdr-selcount">' + esc(CFG.copy.layerSub) + '</span></div><div class="fdr-cards">';
      for (var k = 0; k < layers.length; k++) h += card(layers[k]);
      h += '</div></div>';
    }

    h += '<div class="fdr-save"><div><h3>' + esc(CFG.copy.saveTitle) + '</h3><p>' + esc(CFG.copy.saveBody) + '</p>' +
      '<div id="fdr-save-slot"></div></div>' +
      '<div><h3>' + esc(CFG.copy.shareTitle) + '</h3><p>' + esc(CFG.copy.shareBody) + '</p>' +
      '<button type="button" class="fdr-copybtn" data-a="copy">' + icon('link', '') + '<span>' + esc(CFG.copy.copyLink) + '</span></button></div></div>';

    var contact = CFG.contactEmail
      ? esc(CFG.copy.contactPrefix) + '<a href="mailto:' + esc(CFG.contactEmail) + '">' + esc(CFG.contactEmail) + '</a>'
      : '';
    h += '<div class="fdr-foot"><span class="fdr-contact">' + contact + '</span>' +
      '<button type="button" class="fdr-restart" data-a="restart">' + sun() + esc(CFG.copy.restart) + '</button></div>';

    STAGE.innerHTML = '<div class="fdr-fade">' + h + '</div>';
    announce(CFG.copy.resultsReady);

    // re-attach the Shopify newsletter form (detached at boot, survives innerHTML wipes)
    var slot = document.getElementById('fdr-save-slot');
    if (slot) {
      if (CFG._saved) {
        slot.innerHTML = '<p class="fdr-saved-ok">' + esc(CFG.copy.savedOk) + '</p>';
      } else if (SAVE_FORM) {
        slot.appendChild(SAVE_FORM);
        var ret = SAVE_FORM.querySelector('input[name="return_to"]');
        if (ret) {
          var sep = location.search ? '&' : '?';
          ret.value = location.pathname + location.search + sep + 'saved=1';
        }
      }
    }
    track('result_view', { product: p.handle, score: Math.round(hero.s * 10) / 10, relaxed: relaxed.join(',') });
    revalidate([hero].concat(alts, layers));
  }

  function noteCopy(p) {
    if (A.ceiling && !A.ceiling.skip && A.ceiling.k === 'high') return CFG.copy.noteTall;
    if (p.adj) return CFG.copy.noteAdjustable;
    if (p.bulb === 0 && p.socket) return CFG.copy.noteBulb.replace('{socket}', p.socket);
    return CFG.copy.noteDefault;
  }

  /* live price/availability check on displayed products (anti stale catalog).
     Bounded: each handle fetched once per session (liveCache), one re-render per batch. */
  function revalidate(hits) {
    var refresh = false, pending = 0;
    for (var i = 0; i < hits.length; i++) {
      (function (p) {
        if (liveCache[p.handle]) return;
        pending++;
        fetch(CFG.productBase + p.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var entry = { available: true, price: null };
            if (data) {
              entry.available = !!data.available;
              if (data.price != null) entry.price = Math.round(data.price / 100);
              var v = null;
              for (var j = 0; j < (data.variants || []).length; j++) if (data.variants[j].available) { v = data.variants[j]; break; }
              if (v) {
                if (v.id !== p.vid) { p.vid = v.id; refresh = true; }
                entry.price = Math.round(v.price / 100);
              } else if (!data.available) { entry.available = false; }
            }
            liveCache[p.handle] = entry;
            if (entry.available === false || (entry.price != null && entry.price !== p.price)) refresh = true;
          })
          .catch(function () { /* offline check is best-effort */ })
          .then(function () {
            pending--;
            if (!pending && refresh && hist[hist.length - 1] === 'results') { refresh = false; results(); }
          });
      })(hits[i].p);
    }
  }

  /* ---------- cart (same proven pattern as ma-product-card) ---------- */
  function addToCart(btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var sections = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.dataset.sectionId) sections.push(drawer.dataset.sectionId);
    fetch(CFG.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-vid')), quantity: 1 }], sections: sections.join(',') })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || 'Add to cart failed');
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { resource: {}, data: { source: 'mauk-finder', itemCount: cart ? cart.item_count : undefined, sections: data.sections } }
          }));
          document.dispatchEvent(new CustomEvent('cart:open'));
          track('add_to_cart', { product: btn.getAttribute('data-handle') });
        });
      });
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: CFG.copy.atcError } }));
    }).then(function () { btn.classList.remove('is-loading'); });
  }

  /* ---------- events ---------- */
  var pointerUsed = false, budTimer = null;
  function pick(stepKey, value, advance) {
    var step = stepByKey(stepKey);
    if (!step) return;
    var opt = null;
    for (var i = 0; i < step.options.length; i++) if (step.options[i].k === value) opt = step.options[i];
    A[stepKey] = opt || SKIP;
    track('step', { step: stepKey, choice: value });
    // keyboard users browse radios with arrow keys: never auto-advance on them,
    // they confirm with Enter (see onKeydown)
    if (advance) setTimeout(function () { go(nextScreen()); }, 240);
  }

  function onChange(e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="radio"][data-step]')) {
      var label = t.closest('.fdr-opt');
      var all = STAGE.querySelectorAll('.fdr-opt');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-checked');
      if (label) label.classList.add('is-checked');
      var byPointer = pointerUsed; pointerUsed = false;
      pick(t.getAttribute('data-step'), t.value, byPointer);
    }
    if (t && t.id === 'fdr-budget') {
      refine.budget = parseInt(t.value, 10);
      clearTimeout(budTimer);
      budTimer = setTimeout(results, 150);
    }
  }
  function onKeydown(e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('input[type="radio"][data-step]')) {
      e.preventDefault();
      if (A[e.target.getAttribute('data-step')]) go(nextScreen());
    }
  }
  function onInput(e) {
    if (e.target && e.target.id === 'fdr-budget') {
      var v = parseInt(e.target.value, 10);
      var el = document.getElementById('fdr-budget-label');
      if (el) el.textContent = v >= CFG.budgetMax ? CFG.copy.noLimit : CFG.copy.upTo.replace('{price}', money(v));
    }
  }
  function onClick(e) {
    var el = e.target.closest ? e.target.closest('[data-a]') : null;
    if (!el || !ROOT.contains(el)) return;
    var a = el.getAttribute('data-a');
    if (a === 'back') { e.preventDefault(); back(); }
    else if (a === 'restart') { e.preventDefault(); restart(); }
    else if (a === 'skip') { e.preventDefault(); A[el.getAttribute('data-step')] = SKIP; track('step', { step: el.getAttribute('data-step'), choice: 'skip' }); go(nextScreen()); }
    else if (a === 'tg') { e.preventDefault(); var k = el.getAttribute('data-k'); refine.toggles[k] = !refine.toggles[k]; results(); }
    else if (a === 'atc') { e.preventDefault(); addToCart(el); }
    else if (a === 'copy') {
      e.preventDefault();
      var url = location.href;
      var done = function () {
        var sp = el.querySelector('span');
        if (sp) { sp.textContent = CFG.copy.copied; setTimeout(function () { sp.textContent = CFG.copy.copyLink; }, 2200); }
      };
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (navigator.share && coarse) { navigator.share({ title: document.title, url: url }).catch(function () { /* dismissed */ }); done(); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(done).catch(done); }
      track('share');
    }
  }
  function onFocus(e) {
    var label = e.target && e.target.closest ? e.target.closest('.fdr-opt') : null;
    if (label) label.classList.add('is-focus');
  }
  function onBlur(e) {
    var label = e.target && e.target.closest ? e.target.closest('.fdr-opt') : null;
    if (label) label.classList.remove('is-focus');
  }

  /* ---------- boot ---------- */
  function boot() {
    ROOT = document.getElementById('mauk-finder');
    if (!ROOT) return;
    var cfgEl = ROOT.querySelector('[data-finder-config]');
    if (!cfgEl) return;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    STAGE = ROOT.querySelector('#fdr-stage');
    STAGE.setAttribute('tabindex', '-1');

    // detach the Shopify form once; the JS reference keeps it alive across innerHTML wipes
    SAVE_FORM = ROOT.querySelector('[data-fdr-save-form]');
    if (SAVE_FORM) { SAVE_FORM.remove(); SAVE_FORM.hidden = false; }

    ROOT.addEventListener('click', onClick);
    ROOT.addEventListener('change', onChange);
    ROOT.addEventListener('input', onInput);
    ROOT.addEventListener('keydown', onKeydown);
    ROOT.addEventListener('pointerdown', function () { pointerUsed = true; }, true);
    ROOT.addEventListener('focusin', onFocus);
    ROOT.addEventListener('focusout', onBlur);

    fetch(CFG.catalogUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        CAT = (data && data.items) ? data.items : [];
        IMG_BASE = (data && data.imgBase) || '';
        if (!CAT.length) { STAGE.innerHTML = '<p class="fdr-empty">' + esc(CFG.copy.catalogError) + '</p>'; return; }
        restoreFromUrl();
        pruneAnswers();
        var q = null;
        try { q = new URLSearchParams(location.search); } catch (e) { /* noop */ }
        CFG._saved = !!(q && q.get('saved') === '1');
        var target = nextScreen();
        // rebuild history so "back" walks through restored answers
        hist = [];
        var pl = plan();
        for (var i = 0; i < pl.length - 1; i++) {
          if (pl[i] === target) break;
          if (answered(stepByKey(pl[i]))) hist.push(pl[i]);
        }
        hist.push(target);
        render(target);
        if (target === CFG.steps[0].key && !A[CFG.steps[0].key]) track('start');
      })
      .catch(function () { STAGE.innerHTML = '<p class="fdr-empty">' + esc(CFG.copy.catalogError) + '</p>'; });
  }

  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
